exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--3qqX7 {\n  margin-top: 20px;\n}\n\n.item--3YGUU {\n  margin-bottom: 20px;\n}\n\n.header--14CfS {\n  display: none;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px;\n}\n\n@media (min-width: 1200px) {\n  .header--14CfS {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n  }\n}\n\n.header--14CfS > * {\n  width: 250px;\n  margin-left: 0;\n  padding: 0 5px;\n  margin-right: 10px;\n  color: #878787;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.header--14CfS > *:last-of-type {\n  padding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--3qqX7",
	"item": "item--3YGUU",
	"header": "header--14CfS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/client-search/CompanySearchResults/CompanySearchResults.m.scss
// module id = 1341
// module chunks = 0